import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import arrow_left from "../../images/arrow-left.png";
import { RootState } from '../store';
import { setwizardPageNumber } from '../authslice';
import { useDispatch, useSelector } from 'react-redux';

function BackButton(props: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
  const theme = useSelector((state: RootState) => state.theme.theme);

  const handleBack = () => {
    if ((page - 1) === 0) {
      navigate("/");
      window.location.reload();
    } else {
      dispatch(setwizardPageNumber(page - 1));
    }
  };

  return (
    <span
      onClick={handleBack}
      role="button"
      className={`back-button ${theme === "dark" ? "back-button-dark" : "back-button-light"}`}
    >
      <img
        src={arrow_left}
        width={23}
        alt="Back Arrow"
        className={`arrow-icon ${theme === "dark" ? "arrow-icon-dark" : "arrow-icon-light"}`}
      />
      <span className={`fw-bold small ms-2 ${theme === "dark" ? "text-light" : "text-dark"}`}>
        {t('common.back')}
      </span>
    </span>
  );
}

export default BackButton;
